import React from "react";
import { withRouter } from "react-router-dom";
import { ahoy } from "Tracking";

class PageNavigate extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
      ahoy.trackView();
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(PageNavigate);
